import boletos from './boletos';
import transfers from './transfers';

export const finance = {
    boletos,
    transfers,
};
